import { useState } from "react";
import { Input, message, Spin } from "antd";
import { useLocation, useNavigate } from "react-router-dom";
import axios from "axios";
import { useDispatch, useSelector } from "react-redux";
import { setUser } from "../../Store/slices/User";
import { LoadingOutlined } from "@ant-design/icons";
import { requestPermission } from "../../firebase/firebase";
import useResponsive from "../../hooks/useResponsive";

const OTP = () => {
    const [otp, setOtp] = useState('');
    const navigate = useNavigate();
    const API_URL = import.meta.env.VITE_API_URL;
    const user_status = useSelector((state) => state.user.user);
    const dispatch = useDispatch();
    const [loading, setLoading] = useState(false);
    const [loadingResent, setloadingResent] = useState(false);
    const { isResponsiveMode, isMobile, isTablet } = useResponsive();

    const handleOtpChange = (event) => {
        const value = event.target.value.replace(/[^0-9]/g, '');
        if (value.length <= 6) setOtp(value);
    };

    const handleVerify = async () => {
        try {
            setLoading(true);
            const response = await axios.post(`${API_URL}/users/LoginWithOTP`, {
                mobileNumber: user_status.mobileNumber,
                verificationCode: otp,
            });
            const { accessToken, user } = response.data;

            const roleId = Number(user.roleDetails.id);

            // Check if user is a patient (roleId === 3)
            if (roleId === 3) {
                setLoading(false);
                message.error("This number is registered as a patient and you are not authorized to use the dashboard");
                localStorage.clear();
                sessionStorage.clear();
                navigate('/login');
                return;
            }

            dispatch(setUser({ accessToken, user }));

            // Handle FCM token registration
            try {
                const fcmResponse = await requestPermission(accessToken);

                if (!fcmResponse.success) {
                    message.warning('Notifications may not work properly. Please check your browser settings.');
                    console.warn('FCM Registration failed:', fcmResponse.error);
                }
            } catch (fcmError) {
                console.error('Failed to setup notifications:', fcmError);
                message.warning('Notifications may not work properly. Please check your browser settings.');
            }

            setTimeout(() => {
                switch (roleId) {
                    case 1:
                        navigate('/Sadmin');
                        break;
                    case 4:
                        navigate('/Padmin');
                        break;
                    case 2:
                        navigate('/pharmacist');
                        break;
                    default:
                        navigate('/unauthorized');
                        break;
                }
                setLoading(false);
            }, 1000);
            message.success('Login successful!');

        } catch (error) {
            setLoading(false);
            console.error(error);
            if (error.response && error.response.data && error.response.data.message) {
                message.error(error.response.data.message ? error.response.data.message : "Error while login attempt!");
            } else {
                message.error('An error occurred during login.');
            }
        }
    };

    const handleResendOtp = async () => {
        try {
            setloadingResent(true);
            []
            const response = await axios.post(`${API_URL}/users/resendOTP`, {
                mobileNumber: user_status.mobileNumber,
            });
            setTimeout(() => {
                message.success(response?.data?.message ? response?.data?.message : "OTP Send !");
                setloadingResent(false);
            }, 1000);

        } catch (error) {
            setloadingResent(false);
            console.error(error);
            if (error.response && error.response.data && error.response.data.message) {
                message.error(error.response.data.message ? error.response.data.message : "Error resend OTP");
            } else {
                message.error('An error occurred while resending OTP.');
            }
        }
    };

    return (
        <>
            <div className="flex flex-col md:flex-row h-[100vh]">
                <div
                    className="relative flex-1 bg-[#1351CB] flex items-center justify-center p-4 md:p-8 before:absolute before:inset-0 before:z-0"
                    style={{
                        position: 'relative',
                        minHeight: '50vh'
                    }}
                >
                    <div
                        className="absolute inset-0 opacity-80 z-0"
                        style={{
                            backgroundImage: "url('/assets/images/intro.jpg')",
                            backgroundSize: "cover",
                            backgroundPosition: "center",
                            backgroundRepeat: "no-repeat",
                        }}
                    ></div>
                    <div className="w-full max-w-md bg-white rounded-xl shadow-lg p-6 md:p-8 relative z-10">
                        {isResponsiveMode ?
                            <div className="flex justify-center items-center mb-4">
                                <img
                                    src="/assets/images/CompanyLogo.svg"
                                    alt="Company Logo"
                                    className="w-[50%] h-auto object-contain"
                                />
                            </div> : ""}
                        <h2 className="text-xl md:text-2xl font-bold mb-4 md:mb-6 text-[#1351CB] text-center">Login</h2>
                        <div className="flex flex-col gap-3 md:gap-4">
                            <div>
                                <label className="block text-gray-700 mb-2 text-sm md:text-base">Enter OTP:</label>
                                <div className="flex items-center gap-2">
                                    <Input
                                        maxLength={6}
                                        className="rounded-md outline-none px-2 md:px-3 py-2 flex-1 text-sm md:text-base"
                                        type="text"
                                        value={otp}
                                        onChange={handleOtpChange}
                                        placeholder="652984"
                                    />
                                </div>
                            </div>
                            <div className="mt-3 flex flex-col md:flex-row items-center justify-end gap-3">
                                <button className="w-full bg-[#1351CB] hover:bg-[#1142a8] text-white font-bold py-2 px-4 rounded-md transition-colors text-sm md:text-base" onClick={handleResendOtp}>
                                    {loadingResent ? (
                                        <Spin indicator={<LoadingOutlined spin />} />
                                    ) : (
                                        "Resend OTP"
                                    )}
                                </button>
                                <button className="w-full bg-[#1351CB] hover:bg-[#1142a8] text-white font-bold py-2 px-4 rounded-md transition-colors text-sm md:text-base" onClick={handleVerify}>
                                    {loading ? (
                                        <Spin indicator={<LoadingOutlined spin />} />
                                    ) : (
                                        "Verify"
                                    )}
                                </button>
                            </div>
                        </div>
                    </div>
                </div>

                <div className={`flex-1 bg-white flex items-center justify-center p-4 md:p-8 ${isResponsiveMode ? 'hidden' : ''}`}>
                    <div className="max-w-[80%] md:max-w-[50%] w-full">
                        <img
                            src="/assets/images/CompanyLogo.svg"
                            alt="Company Logo"
                            className="w-full h-auto object-contain"
                        />
                    </div>
                </div>
            </div>
        </>
    );
};

export default OTP;
